import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {child, DatabaseReference, get, getDatabase, ref, set} from "firebase/database";
import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {firebaseApp, nodeRefs} from "../../firebase/index.js";
import {webappName} from "../js/AppRoutes.js";


const CUA = " APXDGTL/1.0";
const CK = "Request-Key=";
const CVA = [
	  "dWZATysoKlJIOzkv",
	  "djRyTWs4bWQmNE0k",
	  "MSRHOTg4SVZWQmU3",
	  "eEBgPXdLZHRAPChm",
	  "Tk1oMyBdQkBfVCly",
	  "TT5LRFlsWy0hXXFl",
	  "WzA0fH0yPzN5Vyxn",
	  "aCIpdzQrcidfek1M",
	  "QztXfnFeXXx9d3wu",
	  "Kic5JVAofmdiUEoz",
	  "VF8nbU4sZVlqaDsy",
	  "ZUpOQyE4TlFRdk5n",
	  "PWAvVkpOVHp6e21O",
	  "Xj1mWXNRaSBRVT8l",
	  "SEdmM2JLclBMImtE",
	  "WVZpLFR6K3pTMiJO",
	  "ZiskIHpKbXJgI2Zr",
	  "UnNfOmBHM0V8NXFq",
	  "PiA8NXF4XHN8OCtD",
	  "RjR9eyU9WXkqIls2",
	  "dSB5VktzX14pM0B3",
	  "dGA7NlgsM3Z0Ingq",
	  "UUs0eGA4ZCQ4LCUy",
	  "NHdoQ1hhaShRZD9A",
	  "enFUTzJ4VFhHIC96",
	  "KCRoI2h4YywxIyZP",
	  "N3pOX2ZIbiMiK3Mm",
	  "YiM/SjxnK2hCPW9x",
	  "RnFBXW4yLGt6MEI0",
	  "ND1LeXFUOCJNeWl4",
	  "JmouL3hkIlorSkpC",
	  "PFsmZ0xbKTFIfD9y",
	  "bS0zLk5qY34wOCV4",
	  "NGEtO11lKVgwY1Fu",
	  "KWdPUCV5ZyVgfkZp",
	  "VDFmKjxRNiFuXXRR",
	  "TixgYiclW1BpIHBi",
	  "Rl5vSS9ubXE8Yz9a",
	  "aT56N3E0LGY4PWZQ",
	  "NSpDLFI5XTwzPVYr",
	  "YV4kQVNpOkQ2RTNx",
	  "dC58VkpMezM1Sj9S",
	  "InAtKjp3eWQvcCxO",
	  "Mj93XHReLEN1UHN6",
	  "cT00WmZxMWUpaFxK",
	  "VVw5eD53TmNgXlI6",
	  "Jn44aEh2fEtpYz1e",
	  "XVxQbz43d2duU3FM",
	  "VjhgLCxKe3RzJGxM",
	  "amA3dSlpP1pXJTMy",
	  "XFgwbS5SZzh2Unt0",
	  "bFJwIUhEYC1bSGIy",
	  "MFk4PnF7fE5UaGVB",
	  "UiJAbUZsLmMnLUhU",
	  "b3hoZ1RuWkxfUH1T",
	  "ViA1OjlQPF1WSFFW",
	  "UD9lZShLJixLbmtN",
	  "ODs0MkxETDlAU0s2",
	  "V0hbLz9wQXR7b0wm",
	  "OCJWMiBuV2grPXdW",
	  "UzVwMToxYSBObmk1",
	  "Klc6fj9zY2I7WiAg",
	  "TnhCb09PQk1qa1ty",
	  "RU5YNj1aZHg4LCIg"
];


//********************************************************************************
//* FIREBASE
//********************************************************************************


const rootDbRef = ref(getDatabase(firebaseApp));

const PLUS_USERS_NODE = "PLUS_USERS";
const plusUsersNodeRef: DatabaseReference = child(rootDbRef, PLUS_USERS_NODE);

setTimeout(() => nodeRefs.push(plusUsersNodeRef), 5000);


const setAsPlusUser = (uid: string, onSet: () => void) => {
	  const pathRef = child(plusUsersNodeRef, `${uid}`);
	  const methodRef = () => {
			 set(pathRef, true)
						.then(
								  () => {
										 onSet();
								  },
								  (error) => {
										 console.error("Error setting Plus Status: ", error, "Retrying again after 5 sec.");
										 setTimeout(() => methodRef(), 5000);
								  }
						);
	  };
	  methodRef();
};

const getPlusStatus = (uid: string, onGot: (v: boolean) => void) => {
	  const pathRef = child(plusUsersNodeRef, `${uid}`);
	  const methodRef = () => {
			 get(pathRef)
						.then(
								  (value) => {
										 if (value) {
												onGot(value.val() || false);
										 }
								  },
								  (error) => {
										 console.error("Error getting Plus Status: ", error, "Retrying again after 5 sec.");
										 setTimeout(() => methodRef(), 5000);
								  }
						);
	  };
	  methodRef();
};


//********************************************************************************
//* HOOK
//********************************************************************************


function useHookForPlusUserChecking(uid: string): { isPlus: boolean | undefined } {
	  
	  const [isPlus, setIsPlus] = useState(undefined);
	  
	  useEffect(() => {
			 
			 if (/*FALSY->*/ !!!uid) return;
			 
			 //	WHEN COMING FROM ANDROID, GUARANTEED PRESENCE OF:
			 // 			CUSTOM USER AGENT
			 // 			CUSTOM HEADER
			 // 			COOKIE K-V
			 
			 // 	SO, SET STATUS OF USER AS PLUS-USER IN FIREBASE.
			 
			 //	WHEN COMING FROM ANY OTHER PLATFORM, THE CUSTOM TEXTS WILL NOT BE THERE.
			 
			 // 	SO, FIRST CHECK FOR PLUS-STATUS IN FIREBASE.
			 // 		IF PLUS-STATUS IS THERE, DO ACCORDINGLY.
			 // 		ELSE, DO ACCORDINGLY.
			 
			 
			 if (navigator.userAgent?.includes(CUA) && document.cookie?.includes(CK + CVA.join(""))) {
					getPlusStatus(uid, (v) => {
						  if (/*FALSY->*/ !!!v) {
								 setAsPlusUser(uid, () => {
										setIsPlus(true);
								 });
						  } else {
								 setIsPlus(true);
						  }
					});
			 } else {
					getPlusStatus(uid, (v) => {
						  setIsPlus(v);
					});
			 }
			 
	  }, []);
	  
	  const dispatch = useDispatch();
	  
	  const {isPlusUser} = useInMemoryPlusStatus();
	  
	  useEffect(() => {
			 isPlusUser === undefined && dispatch(setInMemoryPlusStatus(({isPlusUser: isPlus}: PlusStatus)));
	  }, [isPlus, dispatch]);
	  
	  return {isPlus};
	  
}


export default useHookForPlusUserChecking;


export const nonPlusLimits: { [key: string]: { numerical: number, textual: string } } = Object.freeze({
	  trip: {numerical: 1, textual: "one trip"},
	  est: {numerical: 2, textual: "two estimations"}
});

export const getMessageFromDev = () => "Message from the developer";

export const getPlusMessage = (isPlus: boolean) => isPlus ?
		  `Thank you for being ${webappName}+ user. This matters a lot to the developer.`
		  :
		  `Thank you for using ${webappName}! Upgrade to ${webappName}+ on Google Play for all features and to support the developer.`;

export const getExtraMessage = () => `The free version allows ${nonPlusLimits.trip.textual} and ${nonPlusLimits.est.textual}.`;

export const getPlusAppLink = () => `https://play.google.com/store/apps/details?id=com.apxdgtl.${webappName.toLowerCase()}plus`;


//********************************************************************************
//* PLUS-USER REDUCER
//********************************************************************************


export const inMemoryPlusStatusSliceName = "inMemoryPlusStatus";

export type PlusStatus = { isPlusUser: boolean | undefined }

const initialState: PlusStatus = {isPlusUser: undefined};

const inMemoryPlusStatusSlice = createSlice({
	  name: inMemoryPlusStatusSliceName,
	  initialState,
	  reducers: {
			 setInMemoryPlusStatus: (state, action: PayloadAction<PlusStatus>) => {
					state.isPlusUser = action.payload.isPlusUser;
			 }
	  }
});

const {setInMemoryPlusStatus} = inMemoryPlusStatusSlice.actions;

const inMemoryPlusStatusReducer = inMemoryPlusStatusSlice.reducer;

const useInMemoryPlusStatus = (): PlusStatus => useSelector((state) => state[inMemoryPlusStatusSliceName]);

export {setInMemoryPlusStatus, inMemoryPlusStatusReducer, useInMemoryPlusStatus};